import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import { useDispatch } from "react-redux";
import { _setIsCollapsed } from "../../../store/slices/global.slice";
import { useEffect } from "react";
import DefaultCalendar from "../../components/calendar/defaultCalendar";

const breadcrumbs = [
  { label: "Calendar", path: "" },
];

const Calendar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(_setIsCollapsed(true));
  }, [])


  return (
    <div className="flex flex-col gap-2 p-4">
      <PageTableHeader
        breadcrumbs={breadcrumbs}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-4 bg-white p-4">
        <DefaultCalendar />
      </div>
    </div>
  );
};


export default Calendar;
